// extracted by mini-css-extract-plugin
module.exports = {"CautionTitle":"CautionTitle_CautionTitle__TKvkw"};